/**
 *
 * Achievements
 *
 */

import { mapActions, mapState, mapGetters } from 'vuex';

import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';
import Spinner from '@/components/Spinner.vue';
import { swalWarning } from '@/utils/swal2';
import { LOADING_MESSAGE } from './Achievements.constants';

export default {
  name: 'Achievements',

  components: {
    SharedHeader,
    SharedFooter,
    Spinner,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
      accountName: '',
      password: '',
      achieveStatus: 0,
      checking: false,
      whenErr: false,
      errMsg: '',
    };
  },

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    ...mapState('Achievements', {
      ms_checkData: 'checkData',
      ms_isRequest: 'isRequest',
    }),
  },

  methods: {
    ...mapActions('Achievements', {
      ma_postAchievementsCheck: 'postAchievementsCheck',
    }),

    async check() {
      if (!this.accountName || !this.password) {
        swalWarning('用户名或密码不能为空');
        return;
      }

      this.checking = true;
      this.whenErr = false;
      this.errMsg = '';

      try {
        await this.ma_postAchievementsCheck({
          accountName: this.accountName,
          password: this.password,
        });
        if (this.ms_checkData.accountValidated) {
          if (this.ms_checkData.infoValidated) {
            if (this.ms_checkData.passportValidated) {
              if (this.ms_checkData.hasRegistration) {
                if (this.ms_checkData.hasPassed) {
                  this.achieveStatus = 1;
                } else {
                  this.achieveStatus = 2;
                }
              } else {
                this.whenErr = true;
                this.errMsg = '请先去cfa官网报名下一次考试，再进行重修课程操作！';
              }
            } else {
              this.whenErr = true;
              this.errMsg = '您的护照号验证不成功，请联系品职客服！';
            }
          } else {
            this.whenErr = true;
            this.errMsg = '没有找到您的成绩信息，请稍候重试或联系品职客服！';
          }
        } else {
          this.whenErr = true;
          this.errMsg = '您的用户名或密码无效，请重试！';
        }
        this.checking = false;
      } catch (err) {
        this.checking = false;
        if (err && err.status && err.status == 302) {
          this.whenErr = true;
          this.errMsg = '连接CFA网站超时';
        }
      }
    },
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
